import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { DragDropContext } from "react-beautiful-dnd";
import MDialog, { ACTION_APPLY, ACTION_CLOSE } from "components/Shared/MDialog.tsx";
import { MSpinner } from "components/Shared";
import QuickListColumn from "components/Homeowner/Dashboard/QuickListColumn";
import { reorder, reorderGroupMap } from "components/Homeowner/Dashboard/reorder";
import { connect } from "react-redux";

const QuickListGroup = props => {

  const [groupMap, setGroupMap] = useState({});
  const [groupNames, setGroupNames] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  //After applying a change in the order of QL's, re-opening the QuickListGroup component was showing the old state of the order of QL's.
  //The state was being updated with the correct sort order properties on the lists, but in the same order they were already in which doesn't work with the QL groups.
  //To get around this, I'm just sorting the QL's every time it mounts.

  useEffect(() => {
    buildMap([...props.quickLists]);
  }, []);

  const buildMap = (items) => {
    if (items.length) {
      const uniqueGroups = [];
      const gMap = [];
      items.forEach(ql => {
        if (ql.isEditable) {
          if (uniqueGroups.indexOf(ql.group) === -1) {
            uniqueGroups.push(ql.group);
          }
          if (!gMap[ql.group]) { gMap[ql.group] = []; }
          gMap[ql.group].push(ql);
        }
      });
      setGroupNames(uniqueGroups);
      setGroupMap(gMap);
      setIsLoading(false);
    }
  };

  function onDragEnd(result) {
    // dropped nowhere
    if (!result.destination) {
      return;
    }
    const source = result.source;
    const destination = result.destination;

    // did not move anywhere - can bail early
    if (source.droppableId === destination.droppableId &&
      source.index === destination.index) {
      return;
    }

    // reordering column
    if (result.type === "COLUMN") {
      const gNames = reorder(
        gNames,
        source.index,
        destination.index,
      );
      setGroupNames(gNames);
      return;
    }

    const data = reorderGroupMap({
      groupMap: groupMap,
      source,
      destination,
    });

    setGroupMap(data.groupMap);
  }

  function onSave(e) {
    e.stopPropagation();
    // grab the groupMap from state and update the group name and sort order for each QL item.
    let items = [];
    let gMap = global.structuredClone(groupMap);
    let gNames = global.structuredClone(groupNames);
    gNames.map((groupName) => {
      if (gMap[groupName].length) {
        gMap[groupName].map((ql, index) => {
          ql.sortOrder = index;
          ql.group = groupName;
          items.push(ql);
        });
      }
    });
    props.onApply(items);
  }

  const getActions = () => {
    let actions = [];
    if (props.onApply) actions.push({ code: ACTION_APPLY, onClick: onSave, helpText: "Save Changes" });
    if (props.onClose) actions.push({ code: ACTION_CLOSE, onClick: props.onClose, helpText: "Cancel Changes" });
    return actions;
  };

  let board;

  if (isLoading) board = <MSpinner />;
  else if (groupNames.length === 0) board = "You don't have any quicklists that you can move";
  else board = (
    <div className="quicklist-group" >
      {groupNames.map((key, index) => (
        <QuickListColumn key={key} index={index} title={key}
          items={groupMap[key]} isScrollable={true} isCombineEnabled={false} />
      ))}
    </div>
  );

  return (
    <MDialog id="QuickList-Group" title="Edit Quick List Group"
      actions={getActions()} width={840} height={700}>
      <DragDropContext onDragEnd={onDragEnd}>
        {board}
      </DragDropContext>
    </MDialog >
  );
};

QuickListGroup.propTypes = {
  groupNames: PropTypes.array.isRequired,
  items: PropTypes.array.isRequired,
  onApply: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isFetchingQuickLists: PropTypes.bool.isRequired
};

const mapStateToProps = state => {
  return {
    quickLists: state.quickList.quickLists,
    isFetchingQuickLists: state.quickList.isFetchingQuickLists,
  };
};

export default connect(mapStateToProps, null)(QuickListGroup);